import { create } from "zustand";

interface PlaybackHealthState {
  audioSuspended: boolean;
  setAudioSuspended: (suspended: boolean) => void;
  reset: () => void;
}

export const usePlaybackHealthStore = create<PlaybackHealthState>((set) => ({
  audioSuspended: false,
  setAudioSuspended: (suspended) => set({ audioSuspended: suspended }),
  reset: () => set({ audioSuspended: false }),
}));
